import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CalculatorSection from './components/CalculatorSection';
import ProductsSection from './components/ProductsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const HomePage = () => {
  useEffect(() => {
    // Update document title
    document.title = 'Carbone Soluções Financeiras - Crédito Consignado em Campinas';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Carbone Soluções Financeiras oferece crédito consignado em Campinas com as melhores taxas. Especialistas em empréstimo INSS, crédito CLT, portabilidade, refinanciamento e financiamento de veículos e imóveis. Atendimento rápido, humano e transparente para sua tranquilidade financeira.');
    }

    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "Carbone Soluções Financeiras",
      "image": "https://static.readdy.ai/image/63cf3097778040faac4f034b416b1ba0/5298a1df8d2fede732e5918725441ce1.png",
      "description": "Especialistas em crédito consignado com atendimento humano, rápido e transparente. Oferecemos empréstimo INSS, crédito CLT, portabilidade, refinanciamento e financiamento de veículos e imóveis.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Campinas",
        "addressRegion": "SP",
        "addressCountry": "BR"
      },
      "telephone": "+55-19-97134-4445",
      "email": "contato@carbonesolucoesfinanceiras.com.br",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      "sameAs": [
        "https://www.instagram.com/carbonesolucoesfinanceiras/",
        "https://www.facebook.com/profile.php?id=61586501853205"
      ],
      "priceRange": "$$"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <TrustSection />
      <CalculatorSection />
      <ProductsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
